import { render, staticRenderFns } from "./contributionStatistics.vue?vue&type=template&id=12355eb5&scoped=true"
import script from "./contributionStatistics.vue?vue&type=script&lang=js"
export * from "./contributionStatistics.vue?vue&type=script&lang=js"
import style0 from "./contributionStatistics.vue?vue&type=style&index=0&id=12355eb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12355eb5",
  null
  
)

export default component.exports